function addToCartPopup(){
    console.log("osiuel")

    $('[js-atc-btn]').click(function(e){
       e.preventDefault();

       const recipientForm = document.querySelector('recipient-form');

      if (recipientForm && !recipientForm.validate()) {
        return; // 🔴 Detiene el POST
      }


      $('[js-add-to-cart-wrapper]').addClass('active');

    // Recopilar las propiedades del formulario de destinatario
      let properties = {};
      const recipientCheckbox = document.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"]:not([type="hidden"])');
      
      if (recipientCheckbox && recipientCheckbox.checked) {
        const recipientEmail = document.querySelector('input[name="properties[Recipient email]"]');
        const recipientName = document.querySelector('input[name="properties[Recipient name]"]');
        const recipientMessage = document.querySelector('textarea[name="properties[Message]"]');
        const recipientSendOn = document.querySelector('input[name="properties[Send on]"]');
        const recipientOffset = document.querySelector('input[name="properties[__shopify_offset]"]');
        
        properties['__shopify_send_gift_card_to_recipient'] = 'on';
        if (recipientEmail && recipientEmail.value) properties['Recipient email'] = recipientEmail.value;
        if (recipientName && recipientName.value) properties['Recipient name'] = recipientName.value;
        if (recipientMessage && recipientMessage.value) properties['Message'] = recipientMessage.value;
        if (recipientSendOn && recipientSendOn.value) properties['Send on'] = recipientSendOn.value;
        if (recipientOffset && recipientOffset.value) properties['__shopify_offset'] = recipientOffset.value;
      }
        jQuery.post('/cart/add.js', {
          items: [
            {  
              quantity: 1,
              id: $('[js-atc-btn]').attr('data-v-id'),
              properties: properties
            }
          ]
        })
        .done(function(data) {
          data = JSON.parse(data);
          $('body').append(`
            <div class="main-pdp-popup" data-toggle="modal" >
              <div class="add-to-cart-notification">
                <div class="loader">
                  <svg class="patagonia-loading" viewBox="0 0 262 50" aria-labelledby="picon--patagonia-loading-desc picon--patagonia-loading-title" id="icon--patagonia-loading" xmlns="http://www.w3.org/2000/svg">
                    <title id="picon--patagonia-loading-title">Loading ...</title>
                      <desc id="picon--patagonia-loading-desc">Patagonia Loading Icon</desc>
                      <path class="mountains" d="M5 44.8l1.8-.7c2.1-.8 4.2-1.6 6.2-2.4.9-.4 1.6-.9 2.2-1.6 1-1.1 1.9-2.2 2.8-3.4.8-1 1.5-2 2.2-3 1.1-1.5 2.3-2.9 3.6-4.2.8-.9 1.7-1.8 2.6-2.7.7-.7 1.2-.6 1.8.1.9 1 1.6 2.2 2.4 3.3 1.2 1.6 2.5 3.1 3.9 4.5.9.8 1.9 1.5 2.9 2.1 2.7 1.5 5.5 2.7 8.4 4 1.4.6 2.9 1.3 4.2 2.1 1 .7 2.2 1.2 3.4 1.5 1.4.3 2.8-.2 3.6-1.3 1.7-2.2 3.3-4.4 5.1-6.6.9-1.2 2-2.3 3-3.5.2-.2.4-.5.7-.7.6-.7 1.7-.7 2.4-.1l.2.2c1.6 1.8 3.3 3.4 5.2 4.9 1.1 1 2.2 2 3.3 2.9.4.4.9.8 1.4 1.1.8.8 2 .8 2.8.1.5-.4 1-.9 1.3-1.4.6-1 1.1-2 1.7-3 .8-1.5 1.7-3 2.6-4.5.3-.5.6-1 1-1.4 1.6-2.2 3.6-4 5.9-5.6.6-.7 1.7-.7 2.3-.1l.1.1c.4.3.8.6 1.1 1 1.2 1.4 2.3 2.9 3.2 4.5.9 1.5 2.2 2.7 3.8 3.4l9.3 4.6.6.3c.6.3.8.3 1.1-.2 1.5-1.8 3.4-3.1 5-4.7.1-.1.2-.2.4-.3.2-.2.5-.2.8-.1.7.3 1.3.5 2 .8 1 .5 2 1 2.9 1.5.6.4 1.4.4 2 0 .6-.4 1.2-.8 1.7-1.3 1.5-1.4 2.9-2.7 4.3-4.2 1.9-1.9 3.7-4 5.6-5.9 1.7-1.7 3-3.7 4.1-5.8.4-.9 1-1.7 1.7-2.4 3.7-4 7.5-8 11.4-11.9.3-.4.9-.5 1.3-.2 1.2.6 2.4 1.2 3.5 2 1.4 1 2 2.5 2.5 4.1.6 1.8 1 3.6 1.3 5.5.5 2.5 1 4.9 1.6 7.3 0 .2.1.3.1.5.3 1.1.3 1.1 1.6 1 1.4-.1 2.7-.5 3.9-1.1.6-.3 1.2-.5 1.8-.6.7-.1 1.4.2 1.8.8.8 1.1 1.5 2.2 2.2 3.4.6 1.1 1.2 2.3 1.8 3.5 1.3 2.9 2.4 5.9 3.4 9l.3.9c.4 1 .6 1.2 1.7 1.1 1-.1 1.9-.3 2.8-.8 1.2-.7 2.4-1.3 3.5-2 1-.6 2-1.1 3-1.6 2-.8 4-1.7 6-2.5.6-.3 1.3-.3 1.9 0 1.6.7 3.2 1.3 4.8 2.1.6.3 1.3.3 1.8 0 .4-.2.9-.4 1.4-.6l7.4-3.3c.3-.1.6-.2.9-.4.4-.2.9-.1 1.1.3.7.8 1.4 1.7 2.1 2.5 1.1 1.2 2.6 2.2 4.1 2.8.8.3 1.6.3 2.4-.1 2.6-1 5.2-2.2 7.7-3.6.9-.6 2.1-.5 3 .2 3.2 2.2 6.6 4.1 9.9 6.2 2 1.2 4 2.4 6 3.5l1.2.7">
                      </path>
                      <path class="mountains-animated" d="M5 44.8l1.8-.7c2.1-.8 4.2-1.6 6.2-2.4.9-.4 1.6-.9 2.2-1.6 1-1.1 1.9-2.2 2.8-3.4.8-1 1.5-2 2.2-3 1.1-1.5 2.3-2.9 3.6-4.2.8-.9 1.7-1.8 2.6-2.7.7-.7 1.2-.6 1.8.1.9 1 1.6 2.2 2.4 3.3 1.2 1.6 2.5 3.1 3.9 4.5.9.8 1.9 1.5 2.9 2.1 2.7 1.5 5.5 2.7 8.4 4 1.4.6 2.9 1.3 4.2 2.1 1 .7 2.2 1.2 3.4 1.5 1.4.3 2.8-.2 3.6-1.3 1.7-2.2 3.3-4.4 5.1-6.6.9-1.2 2-2.3 3-3.5.2-.2.4-.5.7-.7.6-.7 1.7-.7 2.4-.1l.2.2c1.6 1.8 3.3 3.4 5.2 4.9 1.1 1 2.2 2 3.3 2.9.4.4.9.8 1.4 1.1.8.8 2 .8 2.8.1.5-.4 1-.9 1.3-1.4.6-1 1.1-2 1.7-3 .8-1.5 1.7-3 2.6-4.5.3-.5.6-1 1-1.4 1.6-2.2 3.6-4 5.9-5.6.6-.7 1.7-.7 2.3-.1l.1.1c.4.3.8.6 1.1 1 1.2 1.4 2.3 2.9 3.2 4.5.9 1.5 2.2 2.7 3.8 3.4l9.3 4.6.6.3c.6.3.8.3 1.1-.2 1.5-1.8 3.4-3.1 5-4.7.1-.1.2-.2.4-.3.2-.2.5-.2.8-.1.7.3 1.3.5 2 .8 1 .5 2 1 2.9 1.5.6.4 1.4.4 2 0 .6-.4 1.2-.8 1.7-1.3 1.5-1.4 2.9-2.7 4.3-4.2 1.9-1.9 3.7-4 5.6-5.9 1.7-1.7 3-3.7 4.1-5.8.4-.9 1-1.7 1.7-2.4 3.7-4 7.5-8 11.4-11.9.3-.4.9-.5 1.3-.2 1.2.6 2.4 1.2 3.5 2 1.4 1 2 2.5 2.5 4.1.6 1.8 1 3.6 1.3 5.5.5 2.5 1 4.9 1.6 7.3 0 .2.1.3.1.5.3 1.1.3 1.1 1.6 1 1.4-.1 2.7-.5 3.9-1.1.6-.3 1.2-.5 1.8-.6.7-.1 1.4.2 1.8.8.8 1.1 1.5 2.2 2.2 3.4.6 1.1 1.2 2.3 1.8 3.5 1.3 2.9 2.4 5.9 3.4 9l.3.9c.4 1 .6 1.2 1.7 1.1 1-.1 1.9-.3 2.8-.8 1.2-.7 2.4-1.3 3.5-2 1-.6 2-1.1 3-1.6 2-.8 4-1.7 6-2.5.6-.3 1.3-.3 1.9 0 1.6.7 3.2 1.3 4.8 2.1.6.3 1.3.3 1.8 0 .4-.2.9-.4 1.4-.6l7.4-3.3c.3-.1.6-.2.9-.4.4-.2.9-.1 1.1.3.7.8 1.4 1.7 2.1 2.5 1.1 1.2 2.6 2.2 4.1 2.8.8.3 1.6.3 2.4-.1 2.6-1 5.2-2.2 7.7-3.6.9-.6 2.1-.5 3 .2 3.2 2.2 6.6 4.1 9.9 6.2 2 1.2 4 2.4 6 3.5l1.2.7">
                      </path>
                  </svg>
                </div>
                <div class="popup">
                  <div class="cross-svg crossBtnClose" id="crossBtn">
                    <svg width="10" viewBox="0 0 10 10"><path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="#A1A1A1" fill-rule="nonzero"></path></svg>
                  </div>
                  <div>
                    <div>
                      <div class="container-main-title">
                        <h3 class="main-title">Producto agregado al carrito</h3>
                      </div>
                      <div class="adtc-product-details">
                        <div class="image">
                          <img src=${data.items[0]['featured_image']['url']} 
                            width="50px" height="100px"
                          alt=${data.items[0]['featured_image']['alt']}
                          />
                        </div>
                        <div class="adtc-product-details-inner">
                          <h2 class="product-title" cart-popup-title>${data.items[0]['product_title']}</h2>
                          <!--
                          <div class="options">
                            ${renderHtm1(data.items[0])}
                            <p class="variants">Precio: <span class="price">${Utils.formatMoney(data.items[0].price /100)}</span> </p>

                          </div>-->
                          <div class="options mt-lg-5">
                            <!--<p>Precio App Wholesale</p>-->
                            ${renderHtm1(data.items[0])}
                            <input type="hidden" data-wpd-cart-drawer-product-handle="${data.items[0].handle}" data-wpd-cart-drawer-variant-id="${data.items[0].variant_id}" data-wpd-cart-drawer-variant-price="${data.items[0].price}" data-wpd-cart-drawer-variant-compare-at-price="${data.items[0].original_price}" data-wpd-cart-drawer-product-id="${data.items[0].product_id}" data-wpd-cart-drawer-line-price data-wpd-cart-drawer-item="${data.items[0].key}" data-wpd-cart-drawer-quantity="${data.items[0].quantity}" />
                            <p class="variants"><strong><span data-wpd-cart-drawer-product-handle="${data.items[0].handle}" data-wpd-cart-drawer-variant-id="${data.items[0].variant_id}" data-wpd-cart-drawer-variant-price="${data.items[0].price}" data-wpd-cart-drawer-variant-compare-at-price="${data.items[0].original_price}" data-wpd-cart-drawer-product-id="${data.items[0].product_id}" data-wpd-cart-drawer-item="${data.items[0].key}" data-wpd-cart-drawer-quantity="${data.items[0].quantity}" class="price">${Utils.formatMoney(data.items[0].price /100)}</span></strong> </p>

                          </div>
                        </div>
                      </div>
                      <div class="buttons text-center mt-lg-5">
                        <a href="/cart" class="btn btn-lg btn-dark mb-4">Ir al Carrito</a>
                        <a href="javascript:;" class="btn btn-lg btn-orange crossBtnClose" >Seguir comprando</a></div>
                    </div>  
                  </div>
                </div>
              </div>
            </div>
            `)
  
          var theLinks = document.querySelectorAll('.add-to-cart-notification .nav-tabs a');
          var theContentLinks = document.querySelectorAll('.add-to-cart-notification .tab-content .tab-pane');
  
          theLinks.forEach(function (element, index) {
              var linkinterno = element.getAttribute("href");
              element.href = linkinterno + "Interna";
          });
          theContentLinks.forEach(function (element, index) {
              var contenidointerno = element.getAttribute("id");
              element.id = contenidointerno + "Interna";
            });

            // Obtiene el elemento del loader
          const loader = document.querySelector('.loader');
          const mainpdp = document.querySelector('.main-pdp-popup .popup');

            // Oculta el loader después de 2 segundos
          setTimeout(() => {
            loader.style.display = 'none';
            mainpdp.style.opacity = 1;
            }, 2000); // 2000 milisegundos = 2 segundos


              // window.colorNameSnippet = `{% include "color-name" %}`;
           
            // function renderHtm1(item) {
            //   // <span class="size">${data.items[0].variant_options[1]} |</apan
            //     let elm = ''
            //     item.options_with_values.forEach(option => {
            //       elm+= `<p class="variants ${option.name}-${option.value}"> <span>${window.colorNameSnippet}</span> -i- ${option.name}: <span>${option.value}</span> | </p>`
            //     })
            //   return elm;
            // }
                 function renderHtm1(item) {
                  let elm = '';

                  // Detectar si es gift card
                  const isGiftCard = item.product_type === 'Gift Cards' || item.product_title === 'Gift Card';

                  item.options_with_values.forEach(option => {
                    let displayValue = option.value;

                    /*

                    if (option.name.toLowerCase() === 'color') {
                      let cleanValue = option.value
                        .replace(/\(.+\)/, '')
                        .replace(/-.+$/, '')
                        .replace(/\..+$/, '')
                        .trim();

                      displayValue = window.COLOR_TRANSLATIONS[cleanValue] || option.value;
                    } */

                    // Para gift cards no mostrar el nombre de la opción (Color:, Denominations:)
                    const label = isGiftCard ? '' : `${option.name}: `;

                    elm += `
                      <p class="variants ${option.name}-${option.value}">
                        <span>${label}${displayValue}</span> |
                      </p>
                    `;
                  });

                  return elm;
                }

  
            var replaced = $(".main-pdp-popup .options .variants:nth-child(2)").html().replace('Size','Talle'); // Obtenemos el texto a cambiar
            $(".main-pdp-popup .options .variants:nth-child(2)").html(replaced); // Cambiamos el texto
            
            $('[js-add-to-cart-wrapper]').removeClass('active');
            
            jQuery.getJSON('/cart.js').done(function(items){
              $('.site-header__cart .counter').html(items.item_count);
            })
  
            
          const tabBlock = $("#tab-block");
          const tabItem = tabBlock.find("[js-tab-item]");
          const tabPanel = tabBlock.find("[js-tab-panel]");
  
          tabItem.click(function() {
            const index = $(this).index();
  
            tabItem.removeClass('active');
            $(this).addClass('active');
  
            tabPanel.removeClass('active');
            tabPanel.eq(index).addClass('active');
            
          })
  
          $('.crossBtnClose').on('click', function() {
            // $('.main-pdp-popup').modal().hide()
            $('.main-pdp-popup').remove()
            $('[js-add-to-cart-wrapper]').removeClass('active');
          })

          /* funcion para cambiar dinamicamente mensaje de envio

          function decodeHTML(html) {
            const txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
          }

          const precioProducto = data.items[0].price; // centavos

           // Para mostrar con formato
          const precioProductoFormateado = decodeHTML(
            Utils.formatMoney(precioProducto / 100)
          );

          console.log("Precio producto:", precioProductoFormateado);

        // 2. Obtener carrito actualizado
          fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {

            const limite = 15000000;
            const cuotas = 30000000;
            const total = cart.total_price;
            const totalConProducto = cart.total_price + precioProducto;

            const contenedor = document.querySelector('#cart-message p');
            if (!contenedor) return;

            let mensaje = '';

            if (totalConProducto < limite) {
              const diferencia = limite - totalConProducto;

              mensaje = `<strong>¡3 cuotas sin interés!</strong>`;
            } else {
              mensaje = `<strong>¡3 cuotas sin interés y envío gratis!</strong>`;
            }

          /*
          Mensaje basado en el precio total

          if (total < limite) {
            const diferencia = limite - total;
            mensaje = `Sumá <strong>${formatMoney(diferencia)}</strong> para <strong>envío gratis. Ya contás con 3 cuotas sin interés.</strong>`;
          } 
          else {
            mensaje = `<strong>¡Envío gratuito y 3 cuotas sin interés!</strong>`;
          }


          if (total < limite) {
            const diferencia = limite - total;
            mensaje = `Sumá <strong>${formatMoney(diferencia)}</strong> más para el <strong>envío gratuito</strong> de tu pedido`;
          } 
          else if (total > limite && total < cuotas) {
            const diferencia = cuotas - total;
            mensaje = `Sumá <strong>${formatMoney(diferencia)}</strong> para <strong>3 cuotas sin interés. Ya contás con envío gratis.</strong>`;
          } 
          else {
            mensaje = `<strong>¡Envío gratuito y 3 cuotas sin interés!</strong>`;
          }

            contenedor.innerHTML = mensaje;

          });  */       
        })
        .fail(function() {
          $('[js-add-to-cart-wrapper]').removeClass('active');
       
          $('body').append(`
            <div class="add-to-cart-notification-fail">
              Ya agregaste este producto al carrito. No quedan más disponibles.
            </div>
          `)
          setTimeout(() => {
            $('.add-to-cart-notification-fail').remove();
          }, 2000)
  
        });
    })

}
addToCartPopup()
document.addEventListener("addToCartPopup:init", addToCartPopup);

class MainProduct extends HTMLElement {
    constructor() {
        super();
        this.variantFields = this.querySelectorAll("[js-variant-field]");
        this.productMediaGallery = document.querySelector("[js-product-media-gallery]");
        this.previousSize = null;
        this.previousDenomination = null;
        this.selectedColor = null;
        this.init();
        this.setInitialCheckedStates();
        this.recipientChecked = false;
    }

    init() {
        this.variantFields.forEach(field => field.addEventListener("click", this.handleVariantChange.bind(this)));
    }

    setInitialCheckedStates() {
      const checkedInputs = this.querySelectorAll('input[type="radio"]:checked');
  
      checkedInputs.forEach(input => {
        const name = input.name.toLowerCase();
  
        if (name.includes("color")) {
          this.selectedColor = input.id;
        }
  
        if (name.includes("size")) {
          this.previousSize = input.id;
        }

        if (name.includes("denomination")) {
          this.previousDenomination = input.id;
        }
      });
    }

    handleVariantChange({ currentTarget }) {
        this.productDetail = currentTarget.closest('[js-product-detail]');
        if (!this.productDetail) {
            console.error('Product detail element not found');
            return;
        }

        const groupName = currentTarget.getAttribute("name");
        const name = groupName.toLowerCase();

        if (name.includes("color")) {
          this.selectedColor = currentTarget.id;
          this.clearSizeChecked();
        }

        if (name.includes("size")) {
          this.previousSize = currentTarget.id;
        }
        if (name.includes("denomination")) {
          this.previousDenomination = currentTarget.id;
        }

        this.updateContent();
    }

    clearSizeChecked() {
      const sizeInputs = this.productDetail.querySelectorAll('input[name*="size"]');
      sizeInputs.forEach(input => input.checked = false);
      this.previousSize = null;

      const denominationInputs = this.productDetail.querySelectorAll('input[name*="denomination"]');
      denominationInputs.forEach(input => input.checked = false);
      this.previousDenomination = null;
    }
    
    checkAndRemoveClass() {
      const sizeInput = this.previousSize
        ? this.productDetail.querySelector(`input[id="${this.previousSize}"]`)
        : null;
  
      if (sizeInput) {
        const wrapper = sizeInput.parentElement;
        if (wrapper) {
          wrapper.classList.remove("js-product-variants");
        }
      }

      const denominationInput = this.previousDenomination
        ? this.productDetail.querySelector(`input[id="${this.previousDenomination}"]`)
        : null;
  
      if (denominationInput) {
        const wrapper = denominationInput.parentElement;
        const formularios = document.querySelector('.recipient-form');
        if (wrapper) {
          wrapper.classList.remove("js-product-variants");
          formularios.classList.remove('inactive-form');
        }
      }
    }

    updateContent() {
    const variantData = JSON.parse(this.productDetail.querySelector('[type="application/json"]').textContent);
    
    const selectedInputs = Array.from(this.productDetail.querySelectorAll('input[type="radio"]:checked'));
    const selectedOptions = selectedInputs.map(input => ({
      name: input.name,
      value: input.value,
      id: input.id,
    }));

    const selectedMap = new Map(selectedOptions.map(opt => [opt.name.toLowerCase(), opt.value]));

    let currentVariant = variantData.find(variant => {
      return variant.options.every((opt, idx) => {
        const optionName = this.variantFields[idx]?.name.toLowerCase();
        return !optionName || selectedMap.get(optionName) === opt;
      });
    });

    if (!currentVariant && selectedOptions.length > 0) {
      currentVariant = variantData.find(variant => {
        return selectedOptions.every(sel => variant.options.includes(sel.value));
      });
    }

    const existingRecipientForm = document.querySelector('recipient-form');

    if (existingRecipientForm) {
      this.recipientChecked = existingRecipientForm.checkboxInput?.checked;
    }

    if (currentVariant) {
      const url = `${this.dataset.url}?variant=${currentVariant.id}&section_id=${this.dataset.originalSection || this.dataset.section}`;
      this.updateURL(currentVariant.id);

      fetch(url)
        .then(res => res.text())
        .then(responseText => {
          const newDoc = new DOMParser().parseFromString(responseText, 'text/html');
          this.replaceContent(newDoc);
          this.updateImage(newDoc);
          this.checkAndRemoveClass();

          document.dispatchEvent(new Event('updateSliderEvent:init'));
          document.dispatchEvent(new Event('updateProductAcordion:init'));
          document.dispatchEvent(new Event('shippingPopupContent:init'));
          document.dispatchEvent(new Event('productSizeGuide:init'));
          document.dispatchEvent(new Event('updateImageZoom:init'));
          document.dispatchEvent(new Event('addToCartPopup:init'));
          document.dispatchEvent(new Event('CuotasPopupContent:init'));
          document.dispatchEvent(new CustomEvent('pdpswatchColor:init'));
          document.dispatchEvent(new CustomEvent('ComplementaryProducts:init'));
        });
    }
    }

    replaceContent(newDocument) {
      const newContent = newDocument.querySelector('[js-product-detail]');
      if (!newContent) return;
  
      this.productDetail.innerHTML = newContent.innerHTML;
      this.variantFields = this.productDetail.querySelectorAll("[js-variant-field]");
      this.init();
  
      // ✅ Restore selected color
      if (this.selectedColor) {
        const colorInput = this.productDetail.querySelector(`input[id="${this.selectedColor}"]`);
        if (colorInput) colorInput.checked = true;
      }
  
      // ✅ Restore selected size
      if (this.previousSize) {
        const sizeInput = this.productDetail.querySelector(`input[id="${this.previousSize}"]`);
        if (sizeInput) sizeInput.checked = true;
      }

      // ✅ Restore selected Denomination
      if (this.previousDenomination) {
        const denominationInput = this.productDetail.querySelector(`input[id="${this.previousDenomination}"]`);
        if (denominationInput) denominationInput.checked = true;
      }

      // Restaurar estado del recipient checkbox
      if (this.recipientChecked) {
        const newRecipientForm = this.productDetail.querySelector('recipient-form');
        
        if (newRecipientForm) {
          const checkbox = newRecipientForm.querySelector(
            'input[name="properties[__shopify_send_gift_card_to_recipient]"]:not([type="hidden"])'
            );

          if (checkbox) {
            checkbox.checked = true;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }

  
      this.checkAndRemoveClass();
    }

    updateURL(variantId) {
        const newUrl = `${this.dataset.url}?variant=${variantId}`;
        window.history.replaceState({}, '', newUrl);
    }

    updateImage(newDocument) {
        const ajaxMedia = newDocument.querySelector('[js-product-media-gallery]');
        console.log(ajaxMedia,'ajaxMedia')
        this.productMediaGallery.innerHTML = ajaxMedia.innerHTML;
    }
  
}

customElements.define('main-product', MainProduct);


function ComplementaryProducts() {
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }
    })
    .catch(e => {
      console.error(e);
    });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);
}
ComplementaryProducts();
document.addEventListener('ComplementaryProducts:init',ComplementaryProducts);

